<template>
  <main>
    <Table :columns="colList" :data="statusList" class="deploy-table"></Table>
  </main>
</template>

<script>
export default {
  name: "Deploy",
  data() {
    return {
      deployList: [],
      colList: [
        {
          title: "System",
          key: "system",
          sortType: "asc",
          width: window.innerWidth <= 768 ? "110" : "150",
        },
        {
          title: "CommitId",
          key: "commitId",
          width: window.innerWidth <= 768 ? "100" : "150",
        },
        {
          title: "Branch",
          key: "branch",
          width: window.innerWidth <= 768 ? "100" : "150",
        },
        {
          title: "Link",
          key: "pageurl",
          render: (h, params) => {
            if (!params.row.pageurl) {
              return h("span")
            }

            const urls = params.row.pageurl.split("&&&")
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  flexDirection: "column",
                },
              },
              urls
                .filter((url) => url)
                .map((url, index) =>
                  h(
                    "a",
                    {
                      key: index,
                      on: {
                        click: () => {
                          window.open(url.trim())
                        },
                      },
                      style: {
                        display: "block",
                        marginTop: "2px",
                        marginBottom: "6px",
                      },
                    },
                    window.innerWidth <= 768 ? "Link" : url.trim()
                  )
                )
            )
          },
        },
      ],
      statusList: [],
    }
  },
  methods: {
    async reset() {
      this.statusList = []

      let promise = await this.$http.get("/checkGit")
      let gitObj = promise.data.git
      this.statusList.push({
        system: "logservice-david",
        commitId: gitObj.commit.id,
        branch: gitObj.branch,
      })

      this.deployList.forEach((item) => {
        this.request(item)
      })
    },
    async request(item) {
      try {
        let response = await this.$http.get(item.serverurl)
        let gitObj = response.data.git
        this.statusList.push({
          system: `${item.system}`,
          commitId: gitObj.commit.id,
          branch: gitObj.branch,
          pageurl: item.frontendpage + "&&&" + item.backendpage,
        })
      } catch (error) {
        this.$Message.error({
          background: true,
          content: `ERROR: ${error.toString()}`,
        })
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.deployList = this.$store.getters.getDeployList()
      this.reset()
    }, 500)
    setInterval(() => {
      if (this.deployList.length == 0) {
        return
      }
      this.reset()
    }, 10000)
  },
  created() {
    this.$store.dispatch("init")
  },
}
</script>

<style scoped>
.deploy-table {
  width: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  :deep(.ivu-table-wrapper) {
    width: 800px;
    min-width: 100%;
  }

  :deep(.ivu-table-cell) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
